/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UpdateSubscriptionRequest model module.
 * @module model/UpdateSubscriptionRequest
 * @version 1.0.0
 */
class UpdateSubscriptionRequest {
    /**
     * Constructs a new <code>UpdateSubscriptionRequest</code>.
     * @alias module:model/UpdateSubscriptionRequest
     * @param email {String} 
     * @param autoRenew {Boolean} 
     */
    constructor(email, autoRenew) { 
        
        UpdateSubscriptionRequest.initialize(this, email, autoRenew);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, email, autoRenew) { 
        obj['email'] = email;
        obj['autoRenew'] = autoRenew;
    }

    /**
     * Constructs a <code>UpdateSubscriptionRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UpdateSubscriptionRequest} obj Optional instance to populate.
     * @return {module:model/UpdateSubscriptionRequest} The populated <code>UpdateSubscriptionRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UpdateSubscriptionRequest();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('autoRenew')) {
                obj['autoRenew'] = ApiClient.convertToType(data['autoRenew'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UpdateSubscriptionRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UpdateSubscriptionRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of UpdateSubscriptionRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}

UpdateSubscriptionRequest.RequiredProperties = ["email", "autoRenew"];

/**
 * @member {String} email
 */
UpdateSubscriptionRequest.prototype['email'] = undefined;

/**
 * @member {Boolean} autoRenew
 */
UpdateSubscriptionRequest.prototype['autoRenew'] = undefined;






export default UpdateSubscriptionRequest;

